var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(false && _vm.cssVars),attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide"}},[_c('router-view',{style:({'position': 'absolute', 'width': '100%', 'height': '100%'})})],1),_c('update-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }